import jquery from 'jquery';
const baseUrl = {
  dev: 'https://externalgtest.guxiansheng.cn',
  pro: 'https://externalg.caixuetang.cn'
}
const baseStr = {
  dev: 'dbca030c5e40526e105ba6da3a603dcc',
  pro: '693e82f636fb56478e8f259232163eea'
}
export function addGatherRes(type, query) {
  const _data = JSON.stringify({ ...query, str: baseStr[type] })
  return new Promise((res, rej) => {
    jquery.ajax({
      url: `${baseUrl[type]}/promotion-collection/gatherRes/addGatherRes`,
      type: 'post',
      dataType: 'json',
      contentType: 'application/json',
      data: _data,
      success(success) {
        res(success)
      },
      error(err) {
        rej(err)
      }
    })
  })
}